import React from "react";
import Navbar from "../Navbar/Navbar";

import { Link } from "react-router-dom";


export default function ActivationStakeInterface() {

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">Activation Stake</h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}>
              <div class="row">
                <div class="box col-md-12">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-6 mr-30">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                               
                                <div className="col-12 justify-content-between text-center">
                                  <h1>Activation Stake</h1>
                                  
                                </div>
                                {/* <!---onclick number increase start--> */}

                                <div class="col-12 d-flex justify-content-center me-auto">
                                  <div className="col-6 text-center">
                                    <Link
                                      to="/ActivationByAdminStake"
                                      className="btn btn-primary"
                                      // id="btnactive"
                                      // style={{
                                      //   color: "white",
                                      //   border: "solid 1px #ffff",
                                      //   padding: "10px 10px",
                                      //   marginTop: "20px",
                                      //   background: "#0d37a5",
                                      // }}
                                      >
                                      Activate
                                    </Link>
                                  </div>
                                  <div className="col-6 text-center">
                                    <Link
                                      to="/UpgradeByAdminStake"
                                       className="btn btn-primary"
                                      // id="btnactive"
                                      // style={{
                                      //   color: "white",
                                      //   border: "solid 1px #ffff",
                                      //   padding: "10px 10px",
                                      //   marginTop: "20px",
                                      //   background: "#0d37a5",
                                      // }}
                                      >
                                      Upgrade
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

